import { FC, memo } from 'react'
import Accordion from './Accordion'
import { HousingMarketResponse } from '@libs/types/generated/housing-market-ui'

interface Props {
  geo: string
  marketData: HousingMarketResponse
}

const HousingMarketFAQ: FC<Props> = ({ geo, marketData }) => {
  const faqs = marketData?.faqs || []

  if (!faqs.length) return null

  const items = faqs.map(faq => ({
    title: faq.question,
    content: <p>{faq.answer}</p>
  }))

  return (
    <div>
      <h2 className="type-heading-two mb-6">{geo} housing market FAQs</h2>

      <Accordion items={items} />
    </div>
  )
}

export default memo(HousingMarketFAQ)
